module.exports = __webpack_public_path__ + "_assets/img/big-maga.34e97b79.svg";